import type { ReactNode } from 'react'
import type { RenderLeafProps } from 'slate-react'
import type { CustomText } from 'modules/community/types/custom-editor'

export interface CustomRenderLeafProps extends RenderLeafProps {
  leaf: CustomText
}

export const Leaf = ({ attributes, children, leaf }: CustomRenderLeafProps): ReactNode => {
  if (leaf.bold) {
    children = <strong>{children}</strong>
  }
  if (leaf.italic) {
    children = <em>{children}</em>
  }
  if (leaf.underline) {
    children = <u>{children}</u>
  }
  return <span {...attributes}>{children}</span>
}
